<template>
    <price-tag-shell :context="context">
        <div class="pt-row pt-row--top pt-row--between">
            <div class="pt-column">
                <div class="pt-headline">{{ tagText('buy') }}</div>
                <div class="pt-big-number">
                    <price-tag-value v-bind="bindField('buyNumber')" />
                    +
                    <price-tag-value v-bind="bindField('freeNumber')" />
                </div>
                <div class="pt-big-number">{{ tagText('free') }}</div>
            </div>
            <price-tag-discount :percent="firstTier.discountPercent" prefix="-" />
        </div>
        <price-tag-product :product="context.product" size="medium" />
    </price-tag-shell>
</template>

<script setup>
import { computed } from 'vue';
import {
    priceTagLayoutProps,
    priceTagLayoutEmits,
    usePriceTagLayout,
} from '@/js/composables/usePriceTagLayout';

const props = defineProps(priceTagLayoutProps);
const emit = defineEmits(priceTagLayoutEmits);

const { bindField, tagText } = usePriceTagLayout(props, emit);

const firstTier = computed(() => props.context.tiers[0] || {});
</script>

<style lang="scss" scoped>
@import '@style/price-tags/price-tag-layout';

.pt-big-number {
    text-transform: uppercase;
}
</style>
